import { useState, useEffect } from 'react';
import { fetcher } from './core';

export function useQuery(initQuery, initOptions = {}) {
  const { url, requireAuth, init = true } = initOptions;

  const [loading, setLoading] = useState(init ? true : false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const fetchQuery = async (
    query = initQuery,
    variables,
    onData = null,
    isLoading = setLoading
  ) => {
    isLoading(true);
    try {
      const { data, errors } = await fetcher(
        { query, variables },
        { url, requireAuth }
      );
      if (errors) {
        setError(errors);
      } else if (error && !errors) {
        setError(null);
      }
      return onData ? onData(data) : data;
    } catch (err) {
      setError(err);
    } finally {
      isLoading(false);
    }
  };

  const refetch = async (query, options = {}) => {
    return fetchQuery(query, options.variables, data => {
      setData(data);
      return data;
    });
  };

  useEffect(() => {
    if (init !== false) {
      refetch(initQuery, initOptions);
    }
  }, []);

  return { loading, error, data, refetch };
}

export default useQuery;
